import { AppThunk } from '../../../store/rootReducer';
import {
  definitionsSelector,
  currentDiagnosticSelector,
} from '../selectors/diagnostic.selectors';
import * as diagnosticActions from '../actions/diagnostic.actions';
import { intersectionBy } from 'lodash';
import { saveManualAbnormalities } from './save-manual-abnormalities.thunk';
import { trackImportDiagnostic } from '../../analytics/thunks/track-import-diagnostic.thunk';

export const copyCurrentDiagnostic =
  (): AppThunk => async (dispatch, getState) => {
    const currentDiagnostic = currentDiagnosticSelector(getState());
    const definitions = definitionsSelector(getState());

    if (currentDiagnostic == null) {
      return;
    }

    const { abnormalities, comment, expertId } = currentDiagnostic;

    const validAbnormalities = intersectionBy(
      abnormalities,
      definitions,
      'name',
    );

    dispatch(trackImportDiagnostic(expertId));
    dispatch(saveManualAbnormalities(validAbnormalities));
    dispatch(diagnosticActions.setComment({ comment }));
  };
